import { CharterPartyRegisterScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeVoyageSource } from '../voyage-source.js';

/** Charter Party Register (ADR 0084 §7): ofis CP yazar ve dönem dışı seyirleri sınıflar. */
export function CharterPartyRegisterPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('voyage.charterParties.title')}>
      <CharterPartyRegisterScreen source={officeVoyageSource} />
    </Shell>
  );
}
